export default {
    data: () => ({
        translations: {
            createWebhook: {
                el: "Δημιουργία Webhook",
                en: "Create Webhook",
                it: "Creare Webhook"
            },
            updateWebhook: {
                el: "Ενημέρωση Webhook",
                en: "Update Webhook",
                it: "Aggiornamento Webhook"
            },
            
            description: {
                el: "Περιγραφή",
                en: "Description",
                it: "Descrizione"
            },

            enabled: {
                el: "Eνεργοποιημένο",
                en: "Enabled",
                it: "Abilitato"
            },

            createdAt: {
                el: "Ημ/νία δημιουργίας",
                en: "Creation Date",
                it: "Data di creazione"
            },
            
            authorization: {
                el: "Εξουσιοδότηση",
                en: "Authorization",
                it: "Autorizzazione"
            },
            eventTypes: {
                el: "Συμβάντα",
                en: "Events",
                it: "Eventi"
            },
            eventType: {
                el: "Συμβάν",
                en: "Event",
                it: "Evento"
            },
            actions : {
                el: "Ενέργειες",
                en: "Actions",
                it: "Azioni"
            },
            disable : {
                el: "Απενεργοποίηση",
                en: "Disable",
                it: "Disattivare"
            },
            enable : {
                el: "Ενεργοποίηση",
                en: "Enable",
                it: "Abilitazione"
            },
            edit : {
                el: "Επεξεργασία",
                en: "Edit",
                it: "Modifica"
            },
            enableAuth : {
                el: "Ενεργοποίηση εξουσιοδότησης",
                en: "Enable Authorization",
                it: "Abilitazione dell'autorizzazione"
            },
            eventsSelected : {
                el: "Επιλεγμένα συμβάντα",
                en: "Events selected",
                it: "Eventi selezionati"
            },
            enableOnSave: {
                el: "Ενεργοποίηση webhook κατά την αποθήκευση",
                en: "Enable event webhook on save",
                it: "Abilita il webhook dell'evento sul salvataggio"
            },
            status: {
                el: "Κατάσταση",
                en: "Status",
                it: "Stato"
            },
            viewLogs: {
                el: "Προβολή αρχείων καταγραφής",
                en: "View logs",
                it: "Visualizza i log"
            },
            logs: {
                el: "Αρχεία καταγραφής",
                en: "Logs",
                it: "Log"
            },
            
            save: {
                el: "Αποθηκευση",
                en: "Save",
                it: "Risparmiare"
            },
            cancel: { 
                el: 'Ακύρωση', 
                en: 'Cancel', 
                it: 'Cancella' 
            },
            addEvents: { 
                el: 'Προσθήκη', 
                en: 'Add Events', 
                it: 'Aggiungi eventi' 
            },
            selectEventsToListen: {
                el: 'Select events to listen to', 
                en: 'Select events to listen to', 
                it: 'Selezionare gli eventi da ascoltare' 
            },
            selectEvents: {
                el: 'Επιλέξτε events', 
                en: 'Select events', 
                it: 'Selezionare gli eventi' 
            },
            editEvents: {
                el: 'Επεξεργασία events', 
                en: 'Edit events', 
                it: 'Modifica eventi' 
            },
            selected: { 
                el: 'Επιλεγμένα', 
                en: 'Selected', 
                it: 'Selezionato' 
            },
            selectAll: {
                el: "Επιλογή Όλων",
                en: "Select All",
                it: "Selezione di Tutti"
            },
            responseStructure: {
                el: 'Δομή', 
                en: 'Response Structure', 
                it: 'Struttura di risposta' 
            },
            responseMapping: { 
                el: 'Χαρτογράφηση', 
                en: 'Response Mapping', 
                it: 'Mappatura delle risposte' 
            },
            logsData: { 
                el: 'Δεδομένα καταγραφής του Webhook', 
                en: 'Webhook Log Data', 
                it: 'Dati di registro Webhook' 
            },
            mappingDescription: {
                el: 'Μπορείτε να ορίσετε το webhook response για κάθε μία από τις παρακάτω κατηγορίες συμβάντων. Ελέγξτε τις διαθέσιμες ιδιότητες στα αριστερά και χρησιμοποιήστε αυτές που θέλετε να συμπεριληφθούν στο response σας, προσθέτοντάς τες στον επεξεργαστή json που είναι διαθέσιμος παρακάτω. Εάν το response παραμείνει κενό, τότε όλες οι διαθέσιμες ιδιότητες θα αποσταλούν με την προεπιλεγμένη μορφή.', 
                en: 'You can set up your webhook response for each of the event categories below. Check the available properties at the left and use the ones you want included in your response, by adding them in the json editor available below. If the response is left empty, then all the available properties will be sent at the default format.', 
                it: "È possibile impostare la risposta del webhook per ciascuna delle categorie di eventi riportate di seguito. Controllare le proprietà disponibili a sinistra e utilizzare quelle che si desidera includere nella risposta, aggiungendole nell'editor json disponibile in basso. Se la risposta viene lasciata vuota, tutte le proprietà disponibili saranno inviate nel formato predefinito." 
            },
            success: {
                el: "Επιτυχία",
                en: "Success",
                it: "Successo"
            },
            fail: {
                el: "Αποτυχία",
                en: "Fail",
                it: "Bocciatura"
            },
            method: {
                el: "Μέθοδος",
                en: "Method",
                it: "Metodo"
            },
            filterbyEvents: {
                el: "φιλτράρισμα ανά συμβάν",
                en: "filter by event type",
                it: "filtrare per tipo di evento"
            },
            filterByStatus: {
                el: "φιλτράρισμα ανά κατάσταση",
                en: "filter by status",
                it: "filtrare per stato"
            },
            resetFilters: {
                el: "Επαναφορά φίλτρων",
                en: "Reset Filters",
                it: "Azzeramento filtri"
            },
            
        }
    })
};
